// src/AudioSpectrum/effects/leafFountain.js
import { getHSLColor } from '../colorUtils.js';

export const drawLeafFountain = (ctx, frequencyData, width, height, fountainRef) => {
  ctx.fillStyle = 'rgba(20, 15, 5, 0.08)';
  ctx.fillRect(0, 0, width, height);
  
  const fountainCount = 3;
  const fountainWidth = width / (fountainCount-1);
  
  for (let f = 0; f < fountainCount; f++) {
    const fountainX = (f + 0.5) * fountainWidth;
    const freqStart = Math.floor((f / fountainCount) * frequencyData.length);
    const freqEnd = Math.floor(((f + 1) / fountainCount) * frequencyData.length);
    const avgValue = frequencyData.slice(freqStart, freqEnd).reduce((a, b) => a + b, 0) / (freqEnd - freqStart);
    
    if (avgValue > 30) {
      const leafCount = Math.floor(avgValue / 30);
      for (let i = 0; i < leafCount; i++) {
        fountainRef.current.push({
          x: fountainX + (Math.random() - 0.5) * 40,
          y: height - 70,
          vx: (Math.random() - 0.5) * 4,
          vy: -(avgValue / 255) * 8 - Math.random() * 2,
          life: 1.0,
          decay: 0.004,
          size: Math.random() * 4 + 2,
          color: getHSLColor(Math.random() * 60 + 15, 70, 50),
          gravity: 0.02,
          trail: [],
          rotation: Math.random() * Math.PI * 2,
          rotationSpeed: (Math.random() - 0.5) * 0.2,
          swayAmount: Math.random() * 2 + 1,
          type: 'leaf'
        });
      }
    }
  }
  
  // 낙엽 파티클 업데이트
  fountainRef.current = fountainRef.current.filter(particle => {
    // 바람에 흔들리는 효과
    const windEffect = Math.sin(Date.now() * 0.003 + particle.x * 0.01) * particle.swayAmount;
    particle.x += particle.vx + windEffect * 0.1;
    particle.y += particle.vy;
    particle.vy += particle.gravity;
    particle.life -= particle.decay;
    particle.rotation += particle.rotationSpeed;
    
    if (particle.life > 0 && particle.y < height + 50) {
      ctx.globalAlpha = particle.life;
      ctx.save();
      ctx.translate(particle.x, particle.y);
      ctx.rotate(particle.rotation);
      
      // 낙엽 모양 그리기
      ctx.fillStyle = particle.color;
      ctx.beginPath();
      ctx.ellipse(0, 0, particle.size, particle.size * 1.5, 0, 0, Math.PI * 2);
      ctx.fill();
      
      // 잎맥 그리기
      ctx.strokeStyle = particle.color.replace(/hsl\((\d+),/, 'hsl($1,');
      ctx.lineWidth = 0.5;
      ctx.beginPath();
      ctx.moveTo(0, -particle.size * 1.2);
      ctx.lineTo(0, particle.size * 1.2);
      ctx.moveTo(-particle.size * 0.5, 0);
      ctx.lineTo(particle.size * 0.5, 0);
      ctx.stroke();
      
      ctx.restore();
      ctx.globalAlpha = 1.0;
      return true;
    }
    return false;
  });
};